import React, { Component } from 'react'
import MUIDataTable from 'mui-datatables'
import gql from 'graphql-tag'
import { Query, withApollo } from 'react-apollo'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import AddDevice from '../AddDevice'
import getLoginId from '../../../utils/getLoginId'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import moment from 'moment'
import getAccountType from '../../../utils/getAccountType.js'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import Loader from '../../common/Loader/Loader'
import axios from 'axios'
import FileSaver from 'file-saver'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  }
})

const GET_VEHICLE_LIST = gql`
  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {
    vehicles: getAllVehicleDetailsByStatus(
      partnerLoginId: $loginId
      status: $status
    ) {
      entityId
      vehicleNumber
      chassisNumber
      clientName
      deviceDetail {
        serial_num
        uniqueDeviceId
        deviceModelId {
          model_name
          devicetype
        }
      }
      simDetail {
        phoneNumber
      }
      vehicleType
      vehicleModel
      firmwareVersion
      createdAt

      grossVehicleWeight
      manufacturingYear
      vehicleSegment
      equipmentTypeClass
      vehicleWheeler
      application
      documentUpload
      baselineDataForFE
      fuelTankCapacity
      adblueCapacity
      baselineDistance
      solutionType
      zonalManager
      keyAccountManager
      channelPartnerName
      technicianName
      isDualEngine
      solution_type

      kvaRating
      bhp
      phase
      engineModel
      gensetController
    }
  }
`

const GET_VEHICLE_LIST_LIMITED = gql`
  query GetAllVehicleDetailsbyStatusLimited($partnerLoginId: Int, $status: Int, $type: String) {
    vehicles: getAllVehicleDetailsbyStatusLimited(partnerLoginId: $partnerLoginId, status: $status, type: $type) {
      entityId
      vehicleNumber
      uniqueId
      vehicleType
      vehicleModel
      clientName
      vehCreatedOn
      grossVehicleWeight
      vehicleSegment
      fuelTankCapacity
      adblueCapacity
      solutionType
      isDualEngine
      solution_type
    }
  }
`

const GET_FILE_FORMAT = gql`
  query getPublicDownloadURL($bucketname: String!, $filename: String!) {
    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)
  }
`

const GET_ZMKAM = gql`
  query getAdminUserDetailsByRole($roleName: [String]) {
    getAdminUserDetailsByRole(
      roleName: $roleName
    ) {
     id
     username
     role
    }
  }
`

class ViewVehicleList extends Component {
  constructor(props) {
    super(props)
    this.classes = props
  }
  clientId = []

  columns = [
    'VEHICLE NO',
    'CHASSIS NO',
    'UNIQUE ID',
    'PHONE NO',
    'DEVICE TYPE',
    'MODEL',
    'CLIENT NAME',
    'CREATED DATE TIME',
    'FIRMWARE VERSION',
    'GROSS VEHICLE WEIGHT',
    'MANUFACTURING YEAR',
    'VEHICLE SEGMENT',
    'EQUIPMENT TYPE CLASS',
    'VEHICLE WHEELER',
    'APPLICATION',
    'BASELINE DATA FOR FE(kmpl)',
    'BASELINE DISTANCE (km)',
    'FUEL TANK CAPACITY',
    'ADBLUE CAPACITY',
    'SOLUTION TYPE',
    'ZONAL MANAGER',
    'KEY ACCOUNT MANAGER',
    'CHANNEL PARTNER',
    'TECHNICIAN',
    'DOUBLE ENGINE',
    'KVA RATING',
    'BHP (BREAK HORSE POWER)',
    'PHASE',
    'ENGINE MODEL',
    'GENSET CONTROLLER'
  ]

  limitedColumns = [
    'VEHICLE NO',
    'UNIQUE ID',
    'VEHICLE TYPE',
    'MODEL',
    'CLIENT NAME',
    'CREATED DATE TIME',
    'GROSS VEHICLE WEIGHT',
    'VEHICLE SEGMENT',
    'FUEL TANK CAPACITY',
    'ADBLUE CAPACITY',
    'SOLUTION TYPE',
    'DOUBLE ENGINE'
  ]

  options = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 15,
    onRowClick: (rowData, dataIndex, rowIndex) => {
      if (['SER'].includes(getAccountType()) || ![2].includes(getLoginId())) {
        const vehicleIndex = dataIndex.dataIndex
        const vehicle = (this.currentVehicles && this.currentVehicles[vehicleIndex]) ? this.currentVehicles[vehicleIndex] : null
        this.props.history.push({
          pathname: '/home/vehicles/edit/' + this.entityId[vehicleIndex],
          state: {
            technicianName: vehicle ? vehicle.technicianName : null,
            vehicleData: vehicle
          }
        })
      } else {
        this.props.openSnackbar('Vehicle cannot be edited')
      }
    }
  }
  state = {
    open: false,
    open1: false,
    zmDetails: [],
    kamDetails: [],
    viewMore: false
  }

  mapToArr(devices) {
    var rowData = []
    var fullData = []
    this.entityId = []
    const { viewMore } = this.state

    devices.forEach(element => {
      rowData = []
      if (viewMore) {
        var zmName = '-';
        var kamName = '-';
        if (element.zonalManager)
          zmName = this.state.zmDetails.find(zm => zm.value == element.zonalManager) ? this.state.zmDetails.find(zm => zm.value == element.zonalManager).label : '-';
        if (element.keyAccountManager)
          kamName = this.state.kamDetails.find(zm => zm.value == element.keyAccountManager) ? this.state.kamDetails.find(zm => zm.value == element.keyAccountManager).label : '-';

        this.entityId.push(element.entityId)
        rowData.push(element.vehicleNumber)
        rowData.push(element.chassisNumber)
        rowData.push(element.deviceDetail.uniqueDeviceId)
        rowData.push(element.simDetail && element.simDetail.phoneNumber)
        rowData.push(element.deviceDetail.deviceModelId.devicetype)
        rowData.push(element.deviceDetail.deviceModelId.model_name)
        rowData.push(element.clientName)
        rowData.push(this.getFormattedDate(element.createdAt))
        rowData.push(element.firmwareVersion)

        rowData.push(element.grossVehicleWeight || '-')
        rowData.push(element.manufacturingYear || '-')
        rowData.push(element.vehicleSegment || '-')
        rowData.push(element.equipmentTypeClass || '-')
        rowData.push(element.vehicleWheeler || '-')
        rowData.push(element.application || '-')

        rowData.push(element.baselineDataForFE || '-')
        rowData.push(element.baselineDistance || '-')
        rowData.push(element.fuelTankCapacity || '-')
        rowData.push(element.adblueCapacity || '-')
let solutionTypeValue = '-'

if (Array.isArray(element.solution_type) && element.solution_type.length > 0) {
  solutionTypeValue = element.solution_type.join(', ') // ["fuel"] → "fuel"
} else if (element.solutionType) {
  solutionTypeValue = element.solutionType
}

rowData.push(solutionTypeValue)
        rowData.push(zmName || '-')
        rowData.push(kamName || '-')
        rowData.push(element.channelPartnerName || '-')
        rowData.push(element.technicianName || '-')

        let valueToPush;
        if (element.isDualEngine === true) {
          valueToPush = 'True';
        } else if (element.isDualEngine === false) {
          valueToPush = 'False';
        } else {
          valueToPush = '-';
        }
        rowData.push(valueToPush);

        rowData.push(element.kvaRating || '-');
        rowData.push(element.bhp || '-');
        rowData.push(element.phase || '-');
        rowData.push(element.engineModel || '-');
        rowData.push(element.gensetController || '-');
      } else {
        // Limited Data mapping
        this.entityId.push(element.entityId)
        rowData.push(element.vehicleNumber)
        rowData.push(element.uniqueId)
        rowData.push(element.vehicleType || '-')
        rowData.push(element.vehicleModel || '-')
        rowData.push(element.clientName || '-')
        rowData.push(this.getFormattedDate(element.vehCreatedOn))
        rowData.push(element.grossVehicleWeight || '-')
        rowData.push(element.vehicleSegment || '-')
        rowData.push(element.fuelTankCapacity || '-')
        rowData.push(element.adblueCapacity || '-')
let solutionTypeValue = '-'

if (Array.isArray(element.solution_type) && element.solution_type.length > 0) {
  solutionTypeValue = element.solution_type.join(', ')
} else if (element.solutionType) {
  solutionTypeValue = element.solutionType
}

rowData.push(solutionTypeValue)
        let dualEngineVal;
        if (element.isDualEngine === true) dualEngineVal = 'True';
        else if (element.isDualEngine === false) dualEngineVal = 'False';
        else dualEngineVal = '-';
        rowData.push(dualEngineVal);
      }
      fullData.push(rowData)
    })

    return fullData
  }

  handleToggleChange = event => {
    this.setState({ viewMore: event.target.checked })
  }

  handleDownload = async (event, fileName) => {
    event.stopPropagation() // Prevent default button behavior
    const bucketName = 'aquila-track-uploads'

    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: bucketName,
        filename: fileName
      },
      errorPolicy: 'all'
    })

    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })

    FileSaver.saveAs(new Blob([res.data]), fileName)
  }

  getStatus = status => {
    if (status === 1) {
      return 'Instock'
    } else if (status === 2) {
      return 'Assigned to Partner'
    } else if (status === 3) {
      return 'Assigned to Client'
    } else if (status === 4) {
      return 'Registered to vehicle'
    }
  }
  getZMKAMDetails = async () => {
    const zmkamDetails = await this.props.client.query({
      query: GET_ZMKAM,
      variables: {
        roleName: ["Zonal Manager(ZM)", "Key Account Manager(KAM)"],
      },
      // fetchPolicy: 'network-only'
    })
    const zmDetails = zmkamDetails.data.getAdminUserDetailsByRole.filter(user => user.role === "Zonal Manager(ZM)").map(user => ({
      value: user.id,
      label: user.username
    }))
    const kamDetails = zmkamDetails.data.getAdminUserDetailsByRole.filter(user => user.role === "Key Account Manager(KAM)").map(user => ({
      value: user.id,
      label: user.username
    }))
    this.setState({ zmDetails: zmDetails, kamDetails: kamDetails })
  }
  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }
  handleClickBulkOpen = () => {
    this.setState({ open1: true })
  }

  handleBulkClose = () => {
    this.setState({ open1: false })
  }
  addBulkUpload = e => {
    this.props.history.push({
      pathname: '/home/DeviceInventory/BulkUpload'
    })
  }
  assignBulkUpload = e => {
    console.log('bulk')
    this.props.history.push({
      pathname: '/home/DeviceInventory/BulkDeviceAssign'
    })
  }
  getFormattedDate = timestamp =>
    moment(timestamp * 1000).format('DD-MM-YYYY HH:mm:ss')

  componentDidMount() {
    this.getZMKAMDetails();
  }

  render() {
    const { classes } = this.props
    return (
      <div className={classes.root}>
        <Grid container spacing={16} direction="row">
          <Grid item xs={12}>
            <Grid container justify="space-between" spacing={16} alignItems="center">
              <Grid item>
                <Grid container spacing={8} alignItems="center">
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="secondary"
                      className={classes.button}
                      onClick={() => this.props.history.goBack()}
                    >
                      <ArrowBackIcon className={classes.iconSmall} />
                    </Button>
                  </Grid>
                  <Grid item>
                    <Typography variant="headline">Vehicles</Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.viewMore}
                      onChange={this.handleToggleChange}
                      color="primary"
                    />
                  }
                  label="View More Details"
                />
              </Grid>
            </Grid>
          </Grid>

          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
          >
            <AddDevice handleClose={this.handleClose} />
          </Dialog>

          <Grid item xs={12}>
            <Query
              query={this.state.viewMore ? GET_VEHICLE_LIST : GET_VEHICLE_LIST_LIMITED}
              variables={
                this.state.viewMore
                  ? {
                    loginId: getLoginId(),
                    status: parseInt(this.props.match.params.status, 10)
                  }
                  : {
                    partnerLoginId: getLoginId(),
                    accountType: localStorage.getItem('Account_type'),
                    status: parseInt(this.props.match.params.status, 10),
                    type: 'db'
                  }
              }
              fetchPolicy={this.state.viewMore ? "network-only" : "cache-first"}
            >
              {({ loading, error, data }) => {
                if (loading) return <Loader />
                if (error) return `Error!: ${error}`

                const vehicles = data.vehicles || []
                // keep a reference to full vehicle objects so onRowClick can pass props/state
                this.currentVehicles = vehicles
                const tableData = this.mapToArr(vehicles)

                return (
                  <MUIDataTable
                    data={tableData}
                    columns={this.state.viewMore ? this.columns : this.limitedColumns}
                    options={this.options}
                  />
                )
              }}
            </Query>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(style)(
  withApollo(withSharedSnackbar(ViewVehicleList))
)


// WEBPACK FOOTER //
// ./src/components/Modules/VehcileDashboard/ViewVehicleList.jsx